define('commons/registration-job-show-errors',['jquery', 'jquery.ui'], function($) {
    
    return function(){
        var $errorsLink = $('a.errors-link');
        var $dialog = $('<div title="Bulk operation errors"></div>').dialog({
        	maxHeight: 400,
            width: 750,
            autoOpen: false
        });
        
        $errorsLink.on('click', function(e){
            e.preventDefault();
            var $this = $(this);
            var errors = $this.data('errors');
            if(!errors || errors.length === 0){
                return true;
            }
            var htmlText = "";
            for( var i = 0; i < errors.length; i++){
                htmlText += '<p>' + errors[i] + '</p>';
            }
            $dialog.html(htmlText).dialog('open');
            $('button.ui-dialog-titlebar-close').focusout();
        });
    };
});
    
